export const enlargeImage = (zoom: any, isFormatAppended: boolean) => {
  let image = new Image()
  image.src = isFormatAppended ? zoom : `data:image/jpeg;base64,${zoom}`
  image.width = 540
  var newTab = window.open('')
  newTab?.document.write(image.outerHTML)
}
